<template lang="pug">
.load-effect
  span
  span
  span
  span
  span
  span
  span
  span
</template>

<script>
export default {

};
</script>

<style lang="less">
@keyframes load {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}

.load-effect {
  width: 25px;
  height: 25px;
  position: relative;
  margin: 0 auto;
  display: inline-block;

  span {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #0096ff;
    position: absolute;
    animation: load 0.7s ease infinite;

    &:nth-child(1) {
      left: 0;
      top: 50%;
      margin-top: -2px;
    }

    &:nth-child(2) {
      left: 3.5px;
      top: 3.5px;
      animation-delay: 0.1s;
      opacity: 0.875;
    }

    &:nth-child(3) {
      left: 50%;
      top: 0;
      margin-left: -2px;
      animation-delay: 0.2s;
      opacity: 0.75;
    }

    &:nth-child(4) {
      top: 3.5px;
      right: 3.5px;
      animation-delay: 0.3s;
      opacity: 0.625;
    }

    &:nth-child(5) {
      right: 0;
      top: 50%;
      margin-top: -2px;
      animation-delay: 0.4s;
      opacity: 0.5;
    }

    &:nth-child(6) {
      right: 3.5px;
      bottom: 3.5px;
      animation-delay: 0.5s;
      opacity: 0.375;
    }

    &:nth-child(7) {
      bottom: 0;
      left: 50%;
      margin-left: -2px;
      animation-delay: 0.6s;
      opacity: 0.25;
    }

    &:nth-child(8) {
      bottom: 3.5px;
      left: 3.5px;
      animation-delay: 0.7s;
      opacity: 0.125;
    }
  }
}
</style>
